import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M5.833 11.667a2.497 2.497 0 00-2.5 2.5c0 1.091-.966 1.666-1.666 1.666C2.433 16.85 3.742 17.5 5 17.5a3.332 3.332 0 003.333-3.333c0-1.384-1.116-2.5-2.5-2.5zm11.425-7.809l-1.116-1.116a.83.83 0 00-1.175 0L7.5 10.208 9.792 12.5l7.466-7.467a.83.83 0 000-1.175z" fill="#54585D" /></svg>);